import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatLegacySlideToggleChange as MatSlideToggleChange } from '@angular/material/legacy-slide-toggle';
import { SportRow } from "@shared/interfaces/sports.interface";

export interface ToggleChangeEvent {
  event: MatSlideToggleChange;
  sport: SportRow;
}

export interface KeyPressEvent {
  event: KeyboardEvent;
  sport: SportRow;
}

export interface PasteEvent {
  event: ClipboardEvent;
  sport: SportRow;
}

export interface InputChangeEvent {
  event: Event;
  sport: SportRow;
}

@Component({
  selector: 'app-sports-table',
  templateUrl: './sports-table.component.html',
  styleUrls: ['./sports-table.component.scss']
})
export class SportsTableComponent {
  @Input() sports: SportRow[] = [];

  @Output() sportsChange = new EventEmitter<SportRow[]>();
  @Output() toggleChange = new EventEmitter<ToggleChangeEvent>();
  @Output() keyPress = new EventEmitter<KeyPressEvent>();
  @Output() paste = new EventEmitter<PasteEvent>();
  @Output() inputChange = new EventEmitter<InputChangeEvent>();

  public displayedColumns: string[] = ['sport', 'determination', 'value'];

  public onToggleChange(event: MatSlideToggleChange, sport: SportRow): void {
    this.toggleChange.emit({ event, sport });
  }

  public onKeyPress(event: KeyboardEvent, sport: SportRow): boolean {
    this.keyPress.emit({ event, sport });
    return true; // Let parent handle the validation
  }

  public onPaste(event: ClipboardEvent, sport: SportRow): void {
    this.paste.emit({ event, sport });
  }

  public onInputChange(event: Event, sport: SportRow): void {
    this.inputChange.emit({ event, sport });
  }

  public getPlaceholder(sport: SportRow): string {
    if (!sport.hasToggle) return 'mm:ss';
    return sport.isDuration ? 'mm:ss' : 'meters';
  }

  public getInputError(sport: SportRow): string {
    return sport.error || '';
  }

  public hasError(sport: SportRow): boolean {
    return !!(sport.error && sport.error.trim() !== '');
  }
}
